import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import { Observable } from 'rxjs';
import { IConfiguracionUsuario, IListaBusquedaUsuarios, ILoginReqBody, ILoginRes, IModificarUsuario, IUsuarioMod, IUsuarios, IUsuariosRes } from 'src/app/interfaces/usuarios';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor(
    private http: HttpClient
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getUsuarios(search: string = '', pageSize: number = 10, pageNumber: number = 1): Observable<IUsuariosRes> {
    const url = `${environment.endpointAdministrativo}/v1/obtenerListaUsuario?page-size=${pageSize}&page-no=${pageNumber}&search=${search}`;
    return this.http.get<IUsuariosRes>(url, { headers: this.getHeaders() });
  }

  buscarUsuarios(username: string): Observable<IListaBusquedaUsuarios> {
    const url = `${environment.endpointAdministrativo}/v1/buscarUsuario?username=${username}`;
    return this.http.get<IListaBusquedaUsuarios>(url, { headers: this.getHeaders() });
  }

  crearUsuario(dataUser: object): Observable<IUsuarios> {
    const url = `${environment.endpointAdministrativo}/v1/crearUsuario`;
    return this.http.post<IUsuarios>(url, dataUser, { headers: this.getHeaders() });
  }

  configuracionUsuario(idUsuario: number | undefined): Observable<IConfiguracionUsuario> {
    const url = `${environment.endpointAdministrativo}/v1/obtenerConfiguracionUsuario?usuarioId=${idUsuario}`;
    return this.http.get<IConfiguracionUsuario>(url, { headers: this.getHeaders() });
  }

  login(body: ILoginReqBody): Observable<ILoginRes> {
    const url = `${environment.endpointAdministrativo}/login`;
    return this.http.post<ILoginRes>(url, body);
  }

  fakeLogin(body: ILoginReqBody): Observable<ILoginRes> {
    const url = `${environment.endpointAdministrativo}/loginFake`;
    return this.http.post<ILoginRes>(url, body);
  }
  modificarUsuario(body: IUsuarioMod): Observable<IUsuarioMod> {
    const url = `${environment.endpointAdministrativo}/v1/editarUsuario`;
    return this.http.put<IUsuarioMod>(url, body, { headers: this.getHeaders() });
  }
  eliminarUsuario(usuarioId: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/eliminarUsuario?usuarioId=${usuarioId}`;
    return this.http.delete<any>(url, { headers: this.getHeaders() });
  }
  modificarEstadoYVigencia(body: IModificarUsuario ): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/modificarEstadoYVigenciaUsuario`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }

  setToken(token: string) { // Validar estructura
    localStorage.setItem('token', token)
  }

  getToken() { // Validar estructura
    const tokenString = localStorage.getItem('token')
    return tokenString ? tokenString : null
    // return tokenString ? JSON.parse(tokenString) : null
  }

  removeToken() {
    localStorage.removeItem('token')
  }


}
